export function signInRequest(data) {
  return {
    type: '@auth/SIGN_IN_REQUEST',
    payload: { data },
  };
}

export function signInRequestRefressToken(data) {
  return {
    type: '@auth/SIGN_IN_REQUEST_REFRESSTOKEN',
    payload: { data },
  };
}

export function signInMicrosoft(params) {
  return {
    type: '@auth/SIGN_IN_MICROSOFT',
    payload: { params },
  };
}

export function signInSuccess(token, user, modules, configs, lang) {
  return {
    type: '@auth/SIGN_IN_SUCCESS',
    payload: { token, user, modules, configs, lang },
  };
}

export function signInSuccessRefressToken(token, user, modules, configs, lang) {
  return {
    type: '@auth/SIGN_IN_SUCCESS_REFRESSTOKEN',
    payload: { token, user, modules, configs, lang },
  };
}

export function signFailure() {
  return {
    type: '@auth/SIGN_FAILURE',
  };
}

export function signOut() {
  return {
    type: '@auth/SIGN_OUT',
  };
}

export function signLogOut(profile) {
  return {
    type: '@auth/SIGN_LOGOUT',
    payload: profile,
  };
}

export function signInRefreshToken(profile) {
  return {
    type: '@auth/SIGN_REFRESHTOKEN',
    payload: profile,
  };
}
